import {Component} from '@angular/core';
import {NavController ,AlertController, ToastController,Events, ModalController } from 'ionic-angular';
import {CartPage} from "../cart/cart";
import {ItemsPage} from "../items/items";
import {OrderViewPage} from "../order-view/order-view";
import {LoginPage} from '../login/login';
import {SearchPage} from '../search/search';
import {Api} from "../../providers/api";
import {ApiOffline} from "../../providers/api-offline";
import { Headers , RequestOptions } from '@angular/http';
import {CartManager} from "../../providers/cart-manager";
import {ArrayUtils} from "../../utils/array-utils";
import * as moment from 'moment';
import * as timeZone from 'moment-timezone';
import {Constants,ApplicationVariables, isIntelliStock} from '../../providers/config';
import { MsgManager } from '../../providers/msg-manager';
import {CART, STOCKCART} from '../../providers/data';
import { PickPackParamsPage } from '../pickpackparams/pickpackparams';
import { PickpacklistPage } from '../pickpacklist/pickpacklist';
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {Storage} from "@ionic/storage";
import {GVLogger} from "../../services/gv-logger";
import {ShipmentslistPage} from "../shipmentslist/shipmentslist";
import { loginUserInfo, orderListStickyVar, ROLE } from '../../providers/data';
import {ConfirmShipmentPage} from "../confirm-shipment/confirm-shipment";




@Component({
  selector: 'page-my-order',
  templateUrl: 'my-order.html'
})
export class MyOrderPage {
  // sample data
  public orders: any =  [];
  public allDataLoaded = false;
  public constants = Constants;
  cart:any;
  isOfflineMode = false;

  adpCustomerInfo : any = {};

  ad:any = {  };

  restrictedToViewOrder = loginUserInfo.restrictedToViewOrder;

  offlineOrdersAvailable = false;
  showAds = 0;
  isIntelliStockfunc = isIntelliStock;
  loggedInUserWarehouse = loginUserInfo.assignedWarehouseName
  loggedInUserWarehouseType = loginUserInfo.assignedWarehouseType
  isWarehouseStaff = ROLE.roleId === 5;
  stockCart: any;
  enteredOrderNumber = orderListStickyVar.enteredOrderNumber
  selectedOrdersType = orderListStickyVar.selectedOrdersType
  selectedSortingType = orderListStickyVar.selectedSortingType
  orderTypesList = [{id:-1, name: "All"},{id:1, name: "Placed"},{id:8, name: "Shipped"},{id:7, name: "Partially Shipped"},{id:5, name: "Ship Ready"},
    {id:2, name: "Hold"}]

  SortingType = [{name : "Oldest on Top", alias : "Ascending"}, {name : "Newest on Top", alias : "Descending"}]
  isB2CSaleChannel = true;
  //   "All"
  // },"Placed","Shipped","Partially Shipped","Hold"]


  constructor(public nav: NavController,
   public api:Api,
   public cartManager:CartManager,
   public arrayUtils:ArrayUtils,
   public alertCtrl:AlertController,
   private msgManager:MsgManager,
   private toastCtrl:ToastController,
   private apiOffline:ApiOffline,
   private events:Events,
   private modalCtrl:ModalController,
   private shipmentCartManager:ShipmentcartManagerProvider,
   public storage:Storage,
   private gVLogger: GVLogger) {

    this.gVLogger.log("constructor called of my order : ");
    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();
    // set sample data
    //this.orders = orderService.getAll();

    this.isOfflineMode = ApplicationVariables.isOffline;

    // IntelliRep Browser Check
      if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
        this.checkOfflineOrders();
      }


      this.events.subscribe("SyncCompleted",()=>{
        // IntelliRep Browser Check
        if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
        this.checkOfflineOrders();
      }
        this.getOrdersResolver(0);
      });

      this.getShowAds();



    this.getOrdersResolver(0);

    this.cart = CART;
    this.stockCart = STOCKCART;




  }


  checkifB2CSaleChannel(order){
    if(order.salesChannel === "B2B Store" || order.salesChannel === "B2B Sales Rep" || order.salesChannel === "B2B Warehouse" || order.orderType === "Transfer Order"){
      return false;
    }else {
      return true;
    }
  }



  getOrdersResolver(itemCount){
    this.gVLogger.log("get order resolver method : ");
    // IntelliRep Browser Check
    if(ApplicationVariables.isOffline && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){

      this.orders = [];
      this.getOrdersOffline();
    }else{
      this.getOrdersLazy(itemCount, this.enteredOrderNumber, this.selectedOrdersType, this.selectedSortingType);
      if(itemCount == 0){
        // IntelliRep Browser Check
         if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
          this.getOrdersOffline();
        }
       // this.getOrdersOffline();
      }
    }
  }

  onChangeSelectedOrdersType(){
    this.gVLogger.log("Typppppppppp " + this.selectedOrdersType)
    orderListStickyVar.selectedOrdersType = this.selectedOrdersType
    var ordersListCount = 0;

    let searchString = "-1";

    if(this.enteredOrderNumber.trim() !== ""){
      searchString = this.enteredOrderNumber;
    }


    var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ this.selectedOrdersType+"&sortingType="+this.selectedSortingType+"&warehouseType=Within Warehouse";
    if(Constants.isWebstore){
      body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
    }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });

    var url = "order/loadByUserSorted";
    if(Constants.isWebstore){
      url = "order/loadByCustomer";
    }

    this.api.post(url+body,null)
      .map(res=> res.json())
      .subscribe(data=>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }else if(data.status == 200){
          // var temp = this.orders;
          var temp = [];


          for(let order of data.data){
            this.gVLogger.log("Recived : "+order.updatedAt);
            order.erpStatus = true;
            temp.push(order);
          }

          this.orders = this.arrayUnique(temp);
          if(data.data == []){
            this.allDataLoaded = true;
          }
          // resolve(true);
        }
      });
  }

  onChangeSelectedSortingType(){
    this.gVLogger.log("Typppppppppp " + this.selectedSortingType)
    orderListStickyVar.selectedSortingType = this.selectedSortingType
    var ordersListCount = 0;

    let searchString = "-1";

    if(this.enteredOrderNumber.trim() !== ""){
      searchString = this.enteredOrderNumber;
    }


    var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ this.selectedOrdersType+"&sortingType="+this.selectedSortingType+"&warehouseType=Within Warehouse";
    if(Constants.isWebstore){
      body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
    }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });

    var url = "order/loadByUserSorted";
    if(Constants.isWebstore){
      url = "order/loadByCustomer";
    }

    this.api.post(url+body,null)
      .map(res=> res.json())
      .subscribe(data=>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }else if(data.status == 200){
          // var temp = this.orders;
          var temp = [];


          for(let order of data.data){
            this.gVLogger.log("Recived : "+order.updatedAt);
            order.erpStatus = true;
            temp.push(order);
          }

          this.orders = this.arrayUnique(temp);
          if(data.data == []){
            this.allDataLoaded = true;
          }
          // resolve(true);
        }
      });
  }

  findOrderByOrderId(){
    var ordersListCount = 0;
    orderListStickyVar.enteredOrderNumber = this.enteredOrderNumber


    let searchString = "-1";

    if(this.enteredOrderNumber.trim() !== ""){
      searchString = this.enteredOrderNumber;
    }
    // else {
    //   this.msgManager.toastMsg("No order number entered. Please enter order number first.");
    //   return
    // }


    var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ this.selectedOrdersType+"&sortingType="+this.selectedSortingType+"&warehouseType=Within Warehouse";
    if(Constants.isWebstore){
      body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
    }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });

    var url = "order/loadByUserSorted";
    if(Constants.isWebstore){
      url = "order/loadByCustomer";
    }

    this.api.post(url+body,null)
      .map(res=> res.json())
      .subscribe(data=>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }else if(data.status == 200){
          // var temp = this.orders;
          var temp = [];


          for(let order of data.data){
            this.gVLogger.log("Recived : "+order.updatedAt);
            order.erpStatus = true;
            temp.push(order);
          }

          this.orders = this.arrayUnique(temp);
          if(data.data == []){
            this.allDataLoaded = true;
          }
          // resolve(true);
        }
      });
  }

  getOrdersOffline(){
    //this.orders = [];
    this.apiOffline.getAllOrders().then((res)=>{
      for(var i=0; i<res.rows.length; i++)
                {
                    var json = JSON.parse(res.rows.item(i).json);
                    this.orders.unshift(json);
                }
    },err=>{
      // alert(JSON.stringify(err));
    });
  }

  async unHold(order) {

    order = await this.getOrderById(order.id);
    let productsList: any = [];
    for(let orderDetail of order.orderDetailDTOs){
      let product: any = orderDetail.productsDTO;
      if(product.productType === 0){
        productsList.push(product);
      }else if(product.productType === 1 && (product.qtyONHAND > 0 && product.status === 1 )){//UD
        productsList.push(product);
      }else{
        this.msgManager.toastMsg("This product is not available in inventory!");
      }
    }

    if(this.cartManager.getProductsCount() > 0 && this.cartManager.getOrderId() != order.id){
      // if(this.cartManager.getOrderId() != order.id){
      let confirm = this.alertCtrl.create({
            title: 'Unsaved cart found.',
            message: " Customer: " + this.cartManager.getCustomerName() + ". What would you like to do?",
            buttons: [
              {
                text: 'Go to old cart', // cancel
                handler: () => {
                  this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
                }
              },
              {
                text: 'Replace with new cart', // agree
                handler: () => {
                        this.cartManager.setCustomer(order.customerDTO);
                        this.cartManager.setOrderMessage(order.orderMessage);
                        this.cartManager.setOrderId(order.id);
                        // this.cartManager.setOrderId(order.orderDetailDTOs);
                        this.cartManager.setShipDate(order.expectedShipmentDate);
                        this.cartManager.setOrderTitle(order.orderTitle);
                        this.cartManager.setOrderStatus(2);
                        this.cartManager.setItems(productsList);
                        this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});

                }
              }
            ]
          });
          confirm.present();
      }
      else{
              this.cartManager.setCustomer(order.customerDTO);
              this.cartManager.setOrderMessage(order.orderMessage);
              this.cartManager.setOrderId(order.id);
              this.cartManager.setOrderTitle(order.orderTitle);
              this.cartManager.setOrderStatus(2);
              this.cartManager.setShipDate(order.expectedShipmentDate);
              this.cartManager.setItems(productsList);
              this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});

      }

  }


  async viewOrder(order){

    order = await this.getOrderById(order.id)
    let orderView = order;

        let productsListLocal: any = [];
            for(let orderDetail of order.orderDetailDTOs){
              let productLocal: any = orderDetail.productsDTO;
              productLocal.consumerPrice = orderDetail.consumerPrice - orderDetail.consumerDiscount
              productLocal.consumerSaleTax = orderDetail.consumerSaleTax
              productLocal.consumerDiscount = orderDetail.consumerDiscount
              productLocal.consumerShippingCost = orderDetail.shippingCost
              // productLocal.quantity = orderDetail.quantity
              productLocal.quantityOrdered = orderDetail.quantity
              productsListLocal.push(productLocal);
            }



            let cart:any = {};

            this.gVLogger.log(order);

            cart.customer = order.customerDTO;
            cart.orderMessage = order.orderMessage;
            cart.expectedShipmentDate = order.expectedShipmentDate;
            cart.shippingServiceName = order.shippingServiceName;
            cart.shippingServiceId = order.shippingServiceValue;
            cart.orderId = order.id;
            cart.items = productsListLocal;

            if(Constants.isWebstore){
              this.nav.push(OrderViewPage,{"subTotalAmount" : order.subTotalAmount, "cart":cart,"shippingCost":order.shippingCost, "priceBeforeShippingCost": order.priceBeforeShippingCost,"TotalPrice":order.totalAmount, "orderView" : orderView})
            }else{
              this.nav.push(OrderViewPage,{"subTotalAmount" : order.subTotalAmount, "cart":cart,"shippingCost":order.shippingCost, "priceBeforeShippingCost": order.priceBeforeShippingCost,"TotalPrice":order.totalAmount, "orderView" : orderView});
            }


  }

  getOrderById(orderId): Promise<any>{
    return new Promise((resolve,reject) => {
      this.api.post("order/loadByOrderId?orderId=" + orderId,null).map(res => res.json()).subscribe(OrderData => {
        this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
        if(OrderData.status === "200") {
          resolve(OrderData.data);
        }
        else {
          this.api.toastMSG("Some thing went wrong while getting orders.");

          reject( null);
        }
      },
        error => {
          this.api.toastMSG("Failed to fetch order data.");
          reject(error);  // ❌ Reject the promise on API failure
        }
        );
    })

  }



  emailOrder(order){
    this.emailCheckBox(order);
  }

  pushToERP(order){
    order.erpStatus = false;

    let body = order;

    this.api.post("order/pushToERP",body)
    .map(res=> res.json())
    .subscribe(data=>{
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status == "200"){
        this.presentToast("Request sent successfully.");
        return true;
      }
    },err=>{
      this.presentToast("Server error.");
    });


  }



  getOrdersLazy(itemCount, searchOrderNumber, orderType, sortingType){
    this.gVLogger.log("get products lazy function method : " + itemCount);

    return new Promise(resolve=>{
    var ordersListCount = itemCount;

    let searchString = "-1";

    if(searchOrderNumber.trim() !== ""){
      searchString = searchOrderNumber;
    }

    // var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ this.selectedOrdersType;
    var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ orderType+"&sortingType="+sortingType+"&warehouseType=Within Warehouse";
    if(Constants.isWebstore){
        body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
    }

    let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

      var url = "order/loadByUserSorted";
      if(Constants.isWebstore){
       url = "order/loadByCustomer";
      }

    this.api.post(url+body,null)
    .map(res=> res.json())
    .subscribe(data=>{
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }else if(data.status == 200){
        var temp = this.orders;


        for(let order of data.data){
          order.erpStatus = true;
          temp.push(order);
        }

        this.orders = this.arrayUnique(temp);

        this.gVLogger.log("Recivedddddddddddddd : " + JSON.stringify(this.orders));
        if(data.data == []){
          this.allDataLoaded = true;
        }
        resolve(true);
      }
    });

    });
  }


  doInfinite(infiniteScroll){
    var arrayLength = this.orders.length;
      this.getOrdersLazy(arrayLength, this.enteredOrderNumber, this.selectedOrdersType, this.selectedSortingType).then(()=>{
        infiniteScroll.complete();
      });


  }

arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i] === a[j])
                a.splice(j--, 1);
        }
    }

    return a;
}


decimalLengthFixed(num,max){
    // alert(num)
  if(num !== undefined)
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  fromNow(date){
    this.gVLogger.log("Date on Server: "+date);
    let utcDate = moment.utc(date).format();
    this.gVLogger.log("TO UTC : "+utcDate);
    //this.gVLogger.log(moment(date));

    var format = 'YYYY-MM-DD hh:mm A ZZ';
    this.gVLogger.log("Local Date: "+timeZone(utcDate,format).tz('Asia/Karachi').format(format));
    return moment(date).fromNow();
    //return date;
  }

  toTimeZone(timeParam) {
    let zone  = "America/Toronto";
    let utcDate = moment.utc(timeParam).format();
    var format = 'YYYY-MM-DD hh:mm A ZZ';
    let corrected:string = timeZone(utcDate, format).tz(zone).format(format)
    corrected = corrected.slice(0, -5);
    return corrected + " ( "+zone+" )";
  }

  toDateZone(dateParam){
    let zone  = "America/Toronto";
    let utcDate = moment.utc(dateParam).format();
    var format = 'YYYY-MM-DD';
    let corrected:string = timeZone(utcDate, format).tz(zone).format(format);
    return corrected + " ( "+zone+" )";
  }


  gotoItemsPage(){
  this.nav.setRoot(ItemsPage);
}

logOut(){
   this.nav.setRoot(LoginPage);
}

goToCart(){
  this.nav.push(CartPage);

}

goToSearch(){
  this.nav.push(SearchPage);
}



 async emailCheckBox(order){

  order = await this.getOrderById(order.id);

  var inputs = [
    {
      name: 'tome',
      label: 'To me',
      type: "checkbox",
      value: "SALEPERSON",
      checked: true
    },
    {
      name: 'tocustomer',
      label: 'To customer',
      type: "checkbox",
      value: "CUSTOMER",
      checked: false
    },
    {
      name: 'toseller',
      label: 'To back office',
      type: "checkbox",
      value: "BACKOFFICE",
      checked: false
    }
  ];


  if(this.constants.isWebstore){

    inputs = [
    {
      name: 'tome',
      label: 'To me',
      type: "checkbox",
      value: "CUSTOMER",
      checked: true
    },
    {
      name: 'tosales',
      label: 'To sale representative',
      type: "checkbox",
      value: "SALEPERSON",
      checked: false
    },
    {
      name: 'toseller',
      label: 'To wholesaler',
      type: "checkbox",
      value: "BACKOFFICE",
      checked: false
    }
  ];

  }

  let alert = this.alertCtrl.create({
  title: 'Email PO Copy',
  inputs: inputs
  ,
  buttons: [
    {
      text: 'Cancel',
      handler: data => {
          return true;

      }
    },
    {
      text: 'Ok',
      handler: data => {
        this.gVLogger.log(data);
        let sendMailList = [];
        if(data.length > 0) {
          //this.gVLogger.log('Get me link');
          //we are calling this method to sent a link to user over mail - to verify their email address.

          for(let d of data){
            if(d === "SALEPERSON"){

            }else {
              sendMailList.push(d);
            }
          }


          let body = order;

          body.sendMailTo = sendMailList;
          body.sendMailTo.push(this.cartManager.getLoggedInUserEmail() + "-supplier");


            this.api.post("order/sendMail",body)
            .map(res=> res.json())
            .subscribe(data=>{
              if(data.status == "401"){ // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                this.nav.setRoot(LoginPage);
              }
              if(data.status == 200){
                this.presentToast("Email sent successfully.");
               return true;
              }
            },err=>{
              this.presentToast("Server error.");
            });

        } else {
          //this.gVLogger.log('Link not required!');
          return true;
        }
      }
    }
  ]
});
alert.present(alert);

}


presentToast(msg){
  var toast = this.toastCtrl.create(
    {
      message:msg,
      duration: 3000,
      position: 'bottom'
  }
    );
  toast.present();
}

  getPickPackShowstatus(status){
    if (status === 6 || this.loggedInUserWarehouseType === "A3PL"){
      return true;
    }else {
      return false
    }
  }


checkOfflineOrders(){
  this.apiOffline.getAllOrders().then((res)=>{
    if(res.rows.length>0)
      {
          this.offlineOrdersAvailable = true;
      }else{
          this.offlineOrdersAvailable = false;
      }
  });
}


syncOrders(){
   this.apiOffline.syncOrdersToServer();
  }

  getShowAds(){

    if(this.cartManager.getAdpCustomerInfo().showAds == 1){
      this.getAdByRoleId();
    }
  }

  getAdByRoleId(){
    this.api.get("/adByRoleId/"+this.cartManager.getSalesPerson().roleId)
    .map(res=>res.json())
    .subscribe(result=>{
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      this.ad = result.data;
      if(this.ad.adText.trim() !== "" ){
        this.showAds = 1;
      }
    });

  }

  getSanitizedURL(url){
    return this.cartManager.sanitizeUrl(url);
  }

  sendEmail(){
    this.gVLogger.log("email");
    let user = this.cartManager.getSalesPerson();
    let body = {
      to:"umar.techviz@gmail.com",
      subject:"Demo Request from "+user.firstName,
      body:" User: "+JSON.stringify(user)
    }
    this.api.post("/email/send",body)
    .map(res=>res.json())
    .subscribe(result =>{
      this.gVLogger.log(result);
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(result.status == "200"){
        this.api.toastMSG("Demo request sent successfully.");
        this.showAds = 0;
      }
    });
  }

  pickPackParams(order){
    let cart:any = {};

        this.gVLogger.log(order);

        cart.customer = order.customerDTO;
        cart.orderMessage = order.orderMessage;
        cart.expectedShipmentDate = order.expectedShipmentDate;
        cart.shippingServiceName = order.shippingServiceName;
        cart.shippingServiceId = order.shippingServiceValue;
        cart.orderId = order.id;

    let modal = this.modalCtrl.create(PickPackParamsPage,{"cart":cart});
        modal.onDidDismiss(data => {
              this.gVLogger.log("data"+ data);
        });
        modal.present();
  }

  async viewPickPackList(order){
    order = await this.getOrderById(order.id);

    console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO " + JSON.stringify(order))
    let orderFromStorge;
    this.gVLogger.log(this.storage.get("orderInStorage"));

    let orderView = order;

    let productsList: any = [];
        for(let orderDetail of order.orderDetailDTOs){
          let product: any = orderDetail.productsDTO;
          product.consumerPrice = orderDetail.consumerPrice
          product.consumerSaleTax = orderDetail.consumerSaleTax
          product.consumerDiscount = orderDetail.consumerDiscount
          product.consumerShippingCost = orderDetail.shippingCost
          productsList.push(product);
          this.shipmentCartManager.addProductToCart(product);
        }


        for(let ship of this.shipmentCartManager.getItems()){
          // UD code in server do
          if(ship.productType === 1){
            if(ship.productInventoryLocationsDTO.length > 0){
            ship.productInventoryLocationsDTO[0].quantityReceived = ship.quantity;
            ship.productInventoryLocationsDTO[0].status = 1;
            }
          }
        }



        let cart:any = {};

        this.gVLogger.log(order);

        cart.customer = order.customerDTO;
        cart.orderMessage = order.orderMessage;
        cart.expectedShipmentDate = order.expectedShipmentDate;
        cart.shippingServiceName = order.shippingServiceName;
        cart.shippingServiceId = order.shippingServiceValue;
        cart.orderId = order.id;
        // cart.items = productsList;
        cart.items = this.shipmentCartManager.getItems();
        cart.orderStatus = order.orderStatus;
        cart.orderTitle = order.orderTitle;

        // this.gVLogger.log(JSON.stringify(cart));
    this.storage.set("orderInStorage", order);
        if(Constants.isWebstore){
          this.nav.push(PickpacklistPage,{"cart":cart,"shippingCost":order.shippingCost, "priceBeforeShippingCost": order.priceBeforeShippingCost,"TotalPrice":order.totalAmount, "orderView" : orderView})
        }else{
          this.nav.push(PickpacklistPage,{"cart":cart,"shippingCost":order.shippingCost, "priceBeforeShippingCost": order.priceBeforeShippingCost,"TotalPrice":order.totalAmount, "orderView" : orderView});

        }

    }

  async viewShipmentsList(order){
    order = await this.getOrderById(order.id);
    let orderFromStorge;
    this.gVLogger.log(this.storage.get("orderInStorage"));

    let orderView = order;

    let productsList: any = [];
    for(let orderDetail of order.orderDetailDTOs){
      let product: any = orderDetail.productsDTO;
      product.consumerPrice = orderDetail.consumerPrice
      product.consumerSaleTax = orderDetail.consumerSaleTax
      product.consumerDiscount = orderDetail.consumerDiscount
      product.consumerShippingCost = orderDetail.shippingCost
      productsList.push(product);
      this.shipmentCartManager.addProductToCart(product);
    }


    for(let ship of this.shipmentCartManager.getItems()){
      // UD code in server do
      if(ship.productType === 1){
        if(ship.productInventoryLocationsDTO.length > 0){
          ship.productInventoryLocationsDTO[0].quantityReceived = ship.quantity;
          ship.productInventoryLocationsDTO[0].status = 1;
        }
      }
    }



    let cart:any = {};

    this.gVLogger.log(order);

    cart.customer = order.customerDTO;
    cart.orderMessage = order.orderMessage;
    cart.expectedShipmentDate = order.expectedShipmentDate;
    cart.shippingServiceName = order.shippingServiceName;
    cart.shippingServiceId = order.shippingServiceValue;
    cart.orderId = order.id;
    // cart.items = productsList;
    cart.items = this.shipmentCartManager.getItems();
    cart.orderStatus = order.orderStatus;
    cart.orderTitle = order.orderTitle;

    // this.gVLogger.log(JSON.stringify(cart));
    this.storage.set("orderInStorage", order);
    if(Constants.isWebstore){
      this.nav.push(ShipmentslistPage,{"cart":cart,"shippingCost":order.shippingCost, "priceBeforeShippingCost": order.priceBeforeShippingCost,"TotalPrice":order.totalAmount, "orderView" : orderView})
    }else{
      this.nav.push(ShipmentslistPage,{"cart":cart,"shippingCost":order.shippingCost, "priceBeforeShippingCost": order.priceBeforeShippingCost,"TotalPrice":order.totalAmount, "orderView" : orderView});

    }

  }

  erpOrderFailureMessage(reason){
    let confirm = this.alertCtrl.create({
      title: 'Erp Failure Reason',
      // message: "Failed due to no ERP configured.Failed due to no ERP configured.Failed due to no ERP configured.",
      message: reason,
      buttons: [
        {
          text: 'OK',
          handler: () => {

          }
        }
      ]
    });
    confirm.present();
  }

  getCurrency(order){
    if(order.currencyCode !== null && order.currencyCode !== undefined && order.currencyCode !== "")
      return  order.currencyCode;
    else
      return this.adpCustomerInfo.selectedCurrencySymbol
  }

  // getLocalTime(createdAt){
  //   const utcDateString = createdAt;
  //   const utcDate = moment.utc(utcDateString, 'YYYY-MM-DD HH:mm:ss.SSS');
  //   const localDateTime = utcDate.local();
  //
  //   // console.log("uuttttccccc "+ utcDate)
  //   // const localDateTime = moment.unix(utcDate).utcOffset(0).local();
  //   const formatDate = moment(localDateTime).format("DD MMM, YYYY [at] hh:mm A")
  //   console.log("ffffffffff " + formatDate)
  //   return formatDate
  // }
}



// WEBPACK FOOTER //
// ./src/pages/my-order/my-order.ts